var map = {
	"./ar.json": 5310,
	"./bn.json": 7581,
	"./cy-GB.json": 4429,
	"./de.json": 5894,
	"./en.json": 4174,
	"./es.json": 6725,
	"./fil.json": 6356,
	"./fr.json": 4605,
	"./gu.json": 6813,
	"./it.json": 3672,
	"./ja.json": 7980,
	"./lv.json": 1103,
	"./nl.json": 4943,
	"./pa.json": 8190,
	"./pl.json": 1029,
	"./pt-PT.json": 5496,
	"./pt.json": 7741,
	"./ro.json": 2354,
	"./ta.json": 7610,
	"./tr.json": 9755,
	"./ur.json": 1946,
	"./zh-Hans.json": 4742
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1360;